import React, { useContext, useEffect, useState } from 'react'
import { AccordionItem } from './types'
import { Accordion } from 'react-bootstrap'
import { collapsePanelContext } from '../../modules/reports/components/collapse-toggle-panel/context'
import { CollapseToggleMode } from '../../modules/reports/types/collapse-toggle'

export function CollapseGroup({
  items,
  className,
  header,
  exporting,
  selected,
}: {
  items: (AccordionItem | null)[]
  className?: string
  header?: JSX.Element
  exporting?: boolean
  selected?: string
}) {
  const openAll = exporting || selected === 'all'
  const activeKey = selected || (items.length === 1 ? '0' : '')
  const activeKeyList = activeKey ? [activeKey] : []
  const defaultActiveKeys = openAll ? items.map((_, idx) => idx.toString()) : activeKeyList

  const panelContext = useContext(collapsePanelContext)
  const [activeKeys, setActiveKeys] = useState<string[]>(defaultActiveKeys)

  useEffect(() => {
    if (openAll && panelContext) {
      panelContext.setCollapsesState(CollapseToggleMode.OpenAll)
    }
  }, [panelContext, openAll])

  useEffect(() => {
    if (!panelContext) {
      return
    }

    const collapseState = panelContext.getCollapsesState()

    if (collapseState === CollapseToggleMode.OpenAll) {
      const allKeys = items.map((_, idx) => idx.toString())
      setActiveKeys(allKeys)
    }
    if (collapseState === CollapseToggleMode.CloseAll) {
      setActiveKeys([])
    }
  }, [panelContext, items])

  const handleSelect = (selectedKey?: string) => {
    if (!selectedKey) {
      return
    }

    const isActive = activeKeys?.includes(selectedKey)

    if (isActive) {
      // Remove selected key from active keys array to close the selected accordion
      if (Array.isArray(activeKeys)) {
        setActiveKeys(activeKeys?.filter((key) => key !== selectedKey))
      } else {
        setActiveKeys([])
      }
    } else {
      // Add selected key to active keys to open the selected accordion
      setActiveKeys(activeKeys ? [...activeKeys, selectedKey] : [selectedKey])
    }
  }

  return (
    <div className={className}>
      {header ? <div className="general-accordion-header">{header}</div> : null}

      <Accordion activeKey={activeKeys} onSelect={(key) => handleSelect(key as string)} alwaysOpen={exporting}>
        {items.map((item, idx) => {
          if (!item) {
            return null
          }

          const key = idx.toString()

          return (
            <Accordion.Item key={`accordion-item-${key}`} eventKey={key}>
              <Accordion.Header>{item.header}</Accordion.Header>
              <Accordion.Body>{item.body}</Accordion.Body>
            </Accordion.Item>
          )
        })}
      </Accordion>
    </div>
  )
}
